<script lang="ts">
    import { Chip, Dot } from "attractions";
    import type { ConstraintDescriptor } from "../types";

    export let constraint: ConstraintDescriptor;

    let showTooltip = false;
</script>

<div
    class="root-container"
    on:mouseenter={() => (showTooltip = true)}
    on:mouseleave={() => (showTooltip = false)}
>
    <div class="left">
        <Chip small>{constraint.f1}</Chip>
    </div>
    <Dot success={constraint.positive} attention={!constraint.positive} />
    <div class="right">
        <Chip small>{constraint.f2}</Chip>
    </div>

    {#if showTooltip}
        <div class="tooltip-content">
            Person who has <strong>{constraint.f1}</strong> as
            <em>{constraint.f1Name}</em>

            {#if constraint.positive}
                <strong class="color-soft-green">has</strong>
            {:else}
                <strong class="color-soft-orange">does not have</strong>
            {/if}

            <strong>{constraint.f2}</strong>
            as
            <em>{constraint.f2Name}</em>
            .
        </div>
    {/if}
</div>

<style lang="scss">
    @use "common.scss";
    @import "theme.scss";

    .root-container {
        position: relative;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 0.5rem;
    }

    .tooltip-content {
        position: absolute;
        top: calc(100% + 0.25rem);
        left: 0px;
        z-index: 100;
        border-radius: 16px;
        margin-left: 0.5rem;
        margin-right: 0.5rem;
        padding: 0.5rem;
        box-shadow: 0px 0px 8px -1px black;
        background: $background;
    }

    .left,
    .right {
        flex-grow: 1;
        flex-basis: 0;
    }
</style>
